import { render, staticRenderFns } from "./UpdateInsurance.vue?vue&type=template&id=2414c7d4&scoped=true"
import script from "./UpdateInsurance.vue?vue&type=script&lang=js"
export * from "./UpdateInsurance.vue?vue&type=script&lang=js"
import style0 from "./UpdateInsurance.vue?vue&type=style&index=0&id=2414c7d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2414c7d4",
  null
  
)

export default component.exports